import { render, staticRenderFns } from "./CnexObsrvDetailMdl.vue?vue&type=template&id=23f12353&"
import script from "./CnexObsrvDetailMdl.vue?vue&type=script&lang=js&"
export * from "./CnexObsrvDetailMdl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports